module.exports = __webpack_public_path__ + "assets/img/NVIDIA-9c16737d.png";